var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('bottom-sheet', {
    attrs: {
      "title": "매칭 승인여부 확인",
      "fullscreen": "",
      "persistent": "",
      "width": "1080",
      "maxWidth": "95%",
      "needsLogin": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var attrs = _ref.attrs,
          on = _ref.on;
        return [_vm._t("activator", null, null, {
          attrs,
          on,
          loading: _vm.loading
        })];
      }
    }], null, true),
    model: {
      value: _vm.shows,
      callback: function ($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-layout', {
    staticClass: "bottom-sheet__contents h-100",
    attrs: {
      "column": "",
      "justify-center": ""
    }
  }, [_vm.loading ? [_c('v-overlay', {
    attrs: {
      "absolute": "",
      "color": "white"
    }
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": "5",
      "color": "primary"
    }
  })], 1)] : [_vm.step == _vm.STEPS.RESULTS.value ? _c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('v-sheet', {
    staticClass: "d-flex flex-column align-center"
  }, [_c('i', {
    staticClass: "icon icon-check mb-20 mb-lg-40"
  }), _c('v-sheet', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm.form.isGranted ? [_c('span', [_vm._v(" 매칭 성사 완료 ")])] : [_c('span', [_vm._v(" 매칭 거부 완료 ")])]], 2), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_vm.form.isGranted ? [_vm._v(" 매칭이 성사되었습니다. "), _c('br'), _vm._v(" 면접기간에 면접진행 해주세요. ")] : [_c('span', [_vm._v(" 매칭이 거부되었습니다. ")])]], 2)]), _c('div', {
    staticClass: "v-btn-group mt-0"
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', [_vm._v("확인")])])], 1)], 1)], 1) : _c('div', {
    staticClass: "d-flex flex-column fill-height justify-center"
  }, [_c('div', {
    staticClass: "text-center mb-20 mb-lg-40"
  }, [_c('h3', {
    staticClass: "tit mb-8 mb-lg-16"
  }, [_vm._v("매칭 승인여부 확인")]), _c('p', {
    staticClass: "page-text--lg grey-6--text"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.value.employer.info.name) + " ")]), _vm._v(" 기업의 면접 요청 승인여부를 선택해주세요. ")])]), _c('common-btns', {
    staticClass: "mb-20 mb-lg-40",
    staticStyle: {
      "flex": "0 1 auto"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }), _c('v-sheet', {
    staticClass: "scroll-primary pr-10",
    staticStyle: {
      "flex": "0 1 auto",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [_c('v-stepper', {
    attrs: {
      "value": `${_vm.form.isGranted}`
    }
  }, [_c('v-stepper-items', [_c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": 'true'
    }
  }, [_c('expo-matching-table', _vm._b({
    staticClass: "mb-20 mb-lg-40",
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  }, 'expo-matching-table', {
    program: _vm.program,
    employer: _vm.value.employer,
    matchings: _vm.matchings
  }, false)), _c('common-loca', _vm._b({
    staticClass: "mb-20 mb-lg-40"
  }, 'common-loca', {
    value: _vm.value
  }, false)), _c('employer-info')], 1), _c('v-stepper-content', {
    staticClass: "pa-0",
    attrs: {
      "step": 'false'
    }
  }, [_c('common-rmsg', {
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.form,
      callback: function ($$v) {
        _vm.form = $$v;
      },
      expression: "form"
    }
  })], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "v-btn-group",
    staticStyle: {
      "flex": "0 1 auto"
    }
  }, [_c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "outlined": "",
      "color": "grey-d"
    },
    on: {
      "click": _vm.exit
    }
  }, [_c('span', {
    staticClass: "grey-6--text"
  }, [_vm._v(" 취소하기 ")])]), _c('v-btn', {
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v(" 응답하기 ")])])], 1)], 1)]], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }